export class TecnicaTerapeutica {
    id: string;
    idTecnica: string;
    mtecnica: any;
    medio: any;
    idValoracion: string;
    fechaIndicacion: string;
    fechaRealizacion: string;
    dnimedIndicacion: string;
    dnimedRealizacion: string;
    expediente: string;
    cantidad: string;
    viaAdministracion: string;
    numVisitaIndicacion: string;
    numVisitaRealizacion: string;
}



// WEBPACK FOOTER //
// ./src/models/tecnicaterapeutica.ts